import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  connectWalletButton: {
    background: "#FFDF00",
    // padding: "12px 20px",
    borderRadius: "50px",
    padding:"10px 24px",
    fontWeight: "600",
    position: "static",
    left: "14.37%",
    right: "14.37%",
    top: "26%",
    width:"100%",
    bottom: "26%",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center",
    color: " #282828",
    border:"2px solid #FFDF00",
    // opacity: "0.8",
    flex: "none",
    order: "0",      
    textTransform: "capitalize",
    flexGrow: "0",
    // margin: "0px 10px",
    marginRight: "auto",
    "&.MuiButton-root:hover": {
      backgroundColor: "#f7d905",
    },
    "&.MuiButton-root": {
      TextTransform: "capitalize",
    },
    "@media (max-width:550px)": {
      // padding: "12px 12px",
      // borderRadius: "12px",
      fontSize: "14px",
      lineHeight:"1",
      "&.MuiButton-root":{
        lineHeight:"1",
        height:"40px",
      }
    },
    "@media (max-width:350px)": {
      // padding: "12px 12px",
      // borderRadius: "12px",
      fontSize: "14px",
      lineHeight:"1",
      "&.MuiButton-root":{
        lineHeight:"1",
        padding:"5px ​10px"
      }
    },
  },
  changeWalletButton: {
    background: "#FFDF00",
    // padding: "12px 20px",
    borderRadius: "50px",
    padding:"10px 24px",
    fontWeight: "600",
    position: "static",
    left: "14.37%",
    right: "14.37%",
    top: "26%",
    width:"100%",
    bottom: "26%",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center",
    color: " #282828",
    border:"2px solid #FFDF00",
    // opacity: "0.8",
    flex: "none",
    order: "0",      
    textTransform: "capitalize",
    flexGrow: "0",
    // margin: "0px 10px",
    marginRight: "auto",
    "&.MuiButton-root:hover": {
      backgroundColor: "#f7d905",
    },
    "&.MuiButton-root": {
      TextTransform: "capitalize",
    },
    "@media (max-width:550px)": {
      // padding: "12px 12px",
      // borderRadius: "12px",
      fontSize: "14px",
      lineHeight:"1",
      "&.MuiButton-root":{
        lineHeight:"1",
        height:"30px",
      }
    },
    "@media (max-width:350px)": {
      // padding: "12px 12px",
      // borderRadius: "12px",
      fontSize: "14px",
      lineHeight:"1",
      "&.MuiButton-root":{
        lineHeight:"1",
        padding:"0"
      }
    },
  },
  wrongWalletButton:{
    background: "rgb(224 23 23)",
    // padding: "12px 20px",
    borderRadius: "50px",
    padding:"10px 24px",
    fontWeight: "600",
    position: "static",
    left: "14.37%",
    right: "14.37%",
    top: "26%",
    width:"100%",
    bottom: "26%",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center",
    color: " #fff",
    // border:"2px solid rgb(224 23 23)",
    // opacity: "0.8",
    flex: "none",
    order: "0",      
    textTransform: "capitalize",
    flexGrow: "0",
    // margin: "0px 10px",
    marginRight: "auto",
    "&.MuiButton-root:hover": {
      backgroundColor: "rgb(255, 16, 16)",
      // border:"2px solid rgb(255, 16, 16)"
    },
    "&.MuiButton-root": {
      TextTransform: "capitalize",
    },
    "@media (max-width:550px)": {
      // padding: "12px 12px",
      // borderRadius: "12px",
      fontSize: "14px",
      lineHeight:"1",
      "&.MuiButton-root":{
        lineHeight:"1",
        height:"40px",
      }
    },
    "@media (max-width:350px)": {
      // padding: "12px 12px",
      // borderRadius: "12px",
      fontSize: "14px",
      lineHeight:"1",
      "&.MuiButton-root":{
        lineHeight:"1",
        // padding:"5px 10px"
      }
    },
  }
}));
